import {
    ATTENDANCE_FAILURE,
    ATTENDANCE_REQUEST,
    ATTENDANCE_SUCCESS,
    ATTENDANCE_SAVE_SUCCESS,
} from 'actions';

const initialState = {
    // competitionId → CompetitionAttendance[]
    dataByCompetition: {},
    isFetched: [],
    isFetching: [],
    // Competitions whose last fetch failed. useAttendance does not retry
    // these by itself: a 403 clears isFetching without setting isFetched, and
    // without this list the hook re-fired the request forever (thousands of
    // 403s a minute for a trainer on the Applications page). A later explicit
    // fetchAttendance (e.g. after a bulk save) still runs and clears it.
    isFailed: [],
};

/**
 * The single source of truth both the Check-In page and every category-page
 * consumer read from — editing attendance from either place is immediately
 * visible in the other because there is only ONE slice, not because of any
 * cross-page sync code.
 */
export const attendanceListReducer = (state = initialState, action) => {
    const { type, data, result, competitionId } = action;
    switch (type) {
        case ATTENDANCE_SUCCESS:
            return {
                ...state,
                isFetched: [...state.isFetched.filter(id => id !== competitionId), competitionId],
                isFetching: state.isFetching.filter(id => id !== competitionId),
                isFailed: (state.isFailed || []).filter(id => id !== competitionId),
                dataByCompetition: {
                    ...state.dataByCompetition,
                    [competitionId]: data,
                },
            };

        case ATTENDANCE_SAVE_SUCCESS: {
            const existing = state.dataByCompetition[competitionId] || [];
            const replaced = existing.some(r => r.id === result.id);
            return {
                ...state,
                dataByCompetition: {
                    ...state.dataByCompetition,
                    [competitionId]: replaced
                        ? existing.map(r => (r.id === result.id ? result : r))
                        : [...existing, result],
                },
            };
        }

        case ATTENDANCE_REQUEST:
            return {
                ...state,
                isFetching: [...state.isFetching, competitionId],
            };

        case ATTENDANCE_FAILURE:
            return {
                ...state,
                isFetching: state.isFetching.filter(id => id !== competitionId),
                isFailed: [...(state.isFailed || []).filter(id => id !== competitionId), competitionId],
            };

        default:
            return state;
    }
};
